// extracted by mini-css-extract-plugin
export var container = "_cx-0";
export var infoIcon = "_cx-2";
export var titleRowCol = "_cx-1";